import { render, staticRenderFns } from "./review-batch.vue?vue&type=template&id=e89b2bf4&"
import script from "./review-batch.vue?vue&type=script&lang=js&"
export * from "./review-batch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports